import { ValidationObserver, ValidationProvider } from "vee-validate";
import "../../../plugins/vee-validate";
import ConfirmDlg from "@/components/popup/confirm-dialog/ConfirmDlg.vue";
import {SocialProgram} from "@/models/SocialProgram";
import {SocialProgramSubscriptionType} from "@/enums/SocialProgramSubscriptionType";
import {PeriodEnum} from "@/enums/PeriodEnum";
import {v4 as uuidv4} from "uuid";
import {uploadImage} from "@/utils/upload-image";
import GalleryPhotosUploadDlg from "@/views/staff/gallery/GalleryPhotosUploadDlg/GalleryPhotosUploadDlg.vue";
import {GalleryImage} from "@/models/GalleryImage";
import * as firebase from "firebase";
import {waitResizedImage} from "@/utils/wait-resized-image";

export default {
  name: "SocialProgram",
  data() {
    return {
      loading: false,
      changesSaved: false,
      socialProgram: new SocialProgram(),
      socialProgramSubscriptionType: SocialProgramSubscriptionType,
      periodEnum: PeriodEnum,
    }
  },
  components: {
    ValidationProvider,
    ValidationObserver,
    ConfirmDlg,
    GalleryPhotosUploadDlg
  },
  async created(){
    await this.$store.dispatch("getLifestyleProgramCategories");
  },
  computed: {
    currentFacility() {
      return this.$store.state.authModule.currentFacility;
    },
    lifestyleProgramCategories() {
      return this.$store.state.socialClubModule.lifestyleProgramCategories
    }
  },
  methods: {
    saveImage(e) {
      const path = `${
        this.currentFacility
      }/social_programs/coverImages/${uuidv4()}`;
      const file = (e.target as HTMLInputElement).files[0];

      uploadImage({
        path,
        file,
        onStart: () => {
          this.loading = true;
        },
        onComplete: async storage => {
          const uploadedImageUrl = await storage.snapshot.ref.getDownloadURL();
          const resizedImageRef = await firebase.storage().ref().child(`${path}_200x200`);

          try {
            const resizedImageUrl = await waitResizedImage(10, resizedImageRef);
            this.socialProgram.imageUrl = uploadedImageUrl;
            this.socialProgram.thumbnailUrl = resizedImageUrl;
          } catch (e) {
            this.socialProgram.imageUrl = uploadedImageUrl;
            this.socialProgram.thumbnailUrl = uploadedImageUrl;
          }

          this.loading = false;
        }
      });
    },
    createProgram() {
      this.socialProgram.facilityId = this.currentFacility;
      this.socialProgram.subscriptionFeePerDay = this.socialProgram.price.toString();
      this.changesSaved = true;
      this.$store.dispatch("createNewSocialProgram", this.socialProgram);
    },
    openGalleryPhotos() {
      (this.$refs.GalleryPhotosUploadDlg as any).open();
    },
    uploadGalleryPhoto(image: GalleryImage) {
      this.socialProgram.imageUrl = image.image;
      this.socialProgram.thumbnailUrl = image?.thumbnailUrl ?? image.image;
      this.$forceUpdate();
    }
  },
  // beforeRouteLeave(to: Route, from: Route, next: Function) {
  //   if (this.changesSaved) next();
  //
  //   this.$refs.confirmationModal
  //     .open(
  //       null,
  //       `Are you sure you want to cancel the lifestyle program?`,
  //       false
  //     )
  //     .then(response => {
  //       next(response && response.agree);
  //     });
  // }
}